import i18n from '@/language/i18n'

export function setPermissions(state, value) {
	state.permissions = value
}

export function setUser(state, value) {
	if (value) {
		const full_name = value.first_name && value.last_name
			? `${value.first_name} ${value.last_name}`.trim()
			: value.first_name || value.last_name || ''

		const avatar = value.avatar
			? (value.avatar.startsWith('http') ? value.avatar : `${process.env.VUE_APP_BASE_API}${value.avatar}`)
			: value.avatar

		state.user = { ...value, full_name, avatar }

		i18n.locale = value.language
		state.theme = value.theme
		localStorage.setItem('@stup:user', JSON.stringify({ ...value, full_name, avatar }))
	} else {
		state.user = value
	}
}

export function setNotifications(state, value) {
	state.notifications = value
}

export function setNotificationStart(state, value) {
	state.notificationStart = value
}

export function setTotalNotifications(state, value) {
	state.totalNotifications = value
}

export function setActionUrl(state, value) {
	state.actionUrl = value
}

export function setLoadingRedirect(state, value) {
	state.loadingRedirect = value
}

export function setTheme(state, value) {
	state.theme = value
}
